import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Kiểm tra phần tử 'root' có tồn tại trong DOM không
const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Không tìm thấy phần tử #root trong HTML.");
}
